export default class Prioridade {
  constructor(id, descricao, solicitante, forma, cliente, data, status) {
    this.id = id;
    this.descricao = descricao;
    this.solicitante = solicitante;
    this.forma = forma;
    this.cliente = cliente;
    this.data = data;
    this.status = status;
  }

  update(prio) {
    this.id = prio.id;
    this.descricao = prio.descricao;
    this.solicitante = prio.solicitante;
    this.frota = prio.frota;
    this.cliente = prio.cliente;
    this.data = prio.data;
    this.status = prio.status;
  }
}
